import { fetchApi } from '@/config/axiosSetting';
import { postRejectOrAcceptParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAcceptOrRejectRecievedImages/postAcceptOrRejectRecievedImages.type';
import { AxiosResponse } from 'axios';

export const postAcceptOrRejectRecievedImagesFunction = (
  params: postRejectOrAcceptParamsType,
): Promise<AxiosResponse<any, any>> => {
  return fetchApi.post(
    `/property/reports/${params.id}/accident_users/damaged/images/corrective/accept_or_reject`,
    {
      damaged_id: params.damaged_id,
      id: params.id,
      ...params.data,
    },
  );
};
